export default {
      id: "ic_tv-usage",
      viewBox: "0 0 16 11",
      url: "/" + "images/icons.3.109.2.svg#ic_tv-usage",
      toString: function () {
        return this.url;
      }
    }